import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CastToComponentPipe } from './dashboard.pipe';
import { DynamicModule } from 'ng-dynamic-component';
//import { ChartsModule } from 'ng2-charts';
import { GridsterModule } from 'angular-gridster2';
import { DashboardItemAgendaComponent } from './dashboard-item/dashboard-item-agenda/dashboard-item-agenda.component';
import { DashboardItemGraphiqueComponent } from './dashboard-item/dashboard-item-graphique/dashboard-item-graphique.component';
import { DashboardItemGridComponent } from './dashboard-item/dashboard-item-grid/dashboard-item-grid.component';
import { DashboardItemMessageComponent } from './dashboard-item/dashboard-item-message/dashboard-item-message.component';
import { DashboardItemElearningComponent } from './dashboard-item/dashboard-item-elearning/dashboard-item-elearning.component';
import { DashboardComponent } from './dashboard.component';
import { SegmentationModule } from '../segmentation';
import { CustomgridModule } from '../customgrid';
import { PipeModule } from '../pipes';
import { SelectModule } from '../select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    DynamicModule.withComponents([
      DashboardItemAgendaComponent,
      DashboardItemGraphiqueComponent,
      DashboardItemGridComponent,
      DashboardItemMessageComponent,
      DashboardItemElearningComponent]),
    //ChartsModule,
    GridsterModule,
    PipeModule,
    SegmentationModule,
    CustomgridModule,
    SelectModule,
    PipeModule
  ],
  declarations: [
    DashboardComponent,
    DashboardItemAgendaComponent,
    DashboardItemGraphiqueComponent,
    DashboardItemGridComponent,
    DashboardItemMessageComponent,
    DashboardItemElearningComponent,
    CastToComponentPipe
  ],
  exports: [
    DashboardComponent,
    DashboardItemAgendaComponent,
    DashboardItemGraphiqueComponent,
    DashboardItemGridComponent,
    DashboardItemMessageComponent,
    DashboardItemElearningComponent,
  ]
})
export class DashboardModule { }
